import TabsAccorion from '../TabsAccordion';
import AsyncImages from '../AsyncImages';

export default function (el) {
	return;
}
